import { sendRequest } from "../sendRequest";

export const addUPI = (vpa) => {
  return sendRequest("post", `/influencer/wallet/razorpay/link-upi`, {
    vpa,
  }).then((res) => res.data);
};
